(function () {
  angular
    .module("akitabox.desktop.room.detail")
    .controller("RoomSchedulesTabController", RoomSchedulesTabController);

  /* @ngInject */
  function RoomSchedulesTabController(
    // Angular
    $scope,
    // Constants
    EVENT_SCHEDULE_CREATE,
    MAINTENANCE_SCHEDULE_STATUS_ACTIVE,
    // Service
    ScheduleService,
    ToastService,
    // Resolve
    building,
    room
  ) {
    var self = this;

    // Attributes
    self.building = building;
    self.room = room;
    self.schedules = null;
    self.status = MAINTENANCE_SCHEDULE_STATUS_ACTIVE;
    self.createOptions = getCreateOptions();

    // Functions
    self.fetchSchedules = fetchSchedules;
    self.fetchAllSchedules = fetchAllSchedules;

    // ------------------------
    //   Events
    // ------------------------

    $scope.$on(EVENT_SCHEDULE_CREATE, onScheduleCreate);

    // ------------------------
    //   Public Functions
    // ------------------------

    function fetchSchedules(skip, limit) {
      var params = {
        skip: skip,
        limit: limit,
        room: self.room._id,
        status: MAINTENANCE_SCHEDULE_STATUS_ACTIVE,
      };

      return ScheduleService.get(building._id, params)
        .then(function (schedules) {
          if (angular.isArray(self.schedules)) {
            self.schedules = self.schedules.concat(schedules);
          } else {
            self.schedules = schedules;
          }
          return schedules.length;
        })
        .catch(ToastService.showError);
    }

    function fetchAllSchedules(limit) {
      var params = {
        skip: 0,
        limit: limit,
        room: self.room._id,
        status: MAINTENANCE_SCHEDULE_STATUS_ACTIVE,
      };

      return ScheduleService.getAll(building._id, params)
        .then(function (schedules) {
          self.schedules = schedules;
          return schedules.length;
        })
        .catch(ToastService.showError);
    }

    // ------------------------
    //   Private Functions
    // ------------------------

    function getCreateOptions() {
      return {
        locals: {
          building: building,
          rooms: [room],
        },
      };
    }

    /**
     * Handle schedule creation event
     *
     * @param {Event}       $event      Angular event
     * @param {Schedule[]}  schedules   List of new schedules
     */
    function onScheduleCreate($event, schedules) {
      for (var i = 0; i < schedules.length; ++i) {
        var schedule = schedules[i];
        if (!schedule.room) {
          continue;
        }
        var roomId = Object.prototype.hasOwnProperty.call(schedule.room, "_id")
          ? schedule.room._id
          : schedule.room;
        if (roomId === self.room._id) {
          self.schedules.unshift(schedules[i]);
        }
      }
    }
  }
})();
